'use client';

import cn from 'classnames';

import { AccordionItem, type AccordionItemProps } from './AccordionItem';

type AccordionProps = {
    items: Array<AccordionItemProps & { id?: string }>;
    className?: string;
};

export const Accordion = ({ className, items }: AccordionProps) => {
    return (
        <div className={cn('disclosure__group', className)}>
            {items.map((item, index) => (
                <AccordionItem
                    key={item.id ?? `${item.title}-${index}`}
                    id={item.id}
                    title={item.title}
                    className={item.className}
                    actionSlot={item.actionSlot}
                    defaultOpen={item.defaultOpen}
                    onOpen={item.onOpen}
                    onClose={item.onClose}
                    dataTestId={item.dataTestId}
                >
                    {item.children}
                </AccordionItem>
            ))}
        </div>
    );
};
